import React from "react"

import FieldAssignees from "../../assignees"
import UserIcon from "../../../../../gd-components/icons/user/user";

type Props = {
    className?      : string

    field           : FieldAssignees

    options         : Option[]
    noLabel?        : boolean

    configOptions?  : any

    onClick?        : callback
    onDelete?       : func

    children?       : any
}

const debug = false
// const debug = "FieldAssignees_InlineValueNotEmpty"

export default function FieldAssignees_InlineValueNotEmpty(props: Props) {
    debug && console.log(debug, 'render', props)

    return (
        <React.Fragment>
            <div className={Classes("ui5-txt-no-accent-default ui5-field-dropdown-inline-editable max-w-300 fl-wrap p-b-5", props.className)} onClick={props.onClick}>
                {_.map(props.options, option => {
                    const user = gd.session.users.get(option.value)!
                    return (
                        <div key        = {option.value}
                             className  = "flex-row-left-center w-100-percent txt-truncate m-t-5">
                            <UserIcon className="m-r-5" size="22" userId={user.id}/>
                            <div className="ui5-txt-default txt-truncate">{user.name}</div>
                        </div>
                    )
                })}
            </div>
            {props.children}
        </React.Fragment>
    );
}
